import React from 'react';
import { useUserReference } from '@hooks';

export interface UserNameDisplayProps {
	userId: number;
}

export const UserNameDisplay: React.FC<UserNameDisplayProps> = ({ userId }) => {
	const { fullName } = useUserReference(userId);

	return <span>{ fullName ?? '' }</span>;
};
